module.exports = __webpack_public_path__ + "img/sejong_gallery5.1317acc6.jpg";